@if (staticMap) {
    <div class="imgContainer">
        <img [src]="staticMap" [alt]="alternativeText" loading="eager" />
    </div>
}
